<router-outlet></router-outlet>
<app-pwa-install-toast></app-pwa-install-toast>
